import { reformatUrl } from './reformat-url';

export const addUtmQueryParams = (url: string): string => {
  const params = new URLSearchParams(window.location.search);
  const utmParts = new Array<string>();

  params.forEach((value, key) => {
    if (key.toLowerCase().startsWith('utm') && url.indexOf(key) === -1) {
      utmParts.push(`${key}=${encodeURIComponent(value)}`);
    }
  });

  if (utmParts.length === 0) {
    return url;
  }

  const separator = url.includes('?') ? '&' : '?';
  return reformatUrl(`${url}${separator}${utmParts.join('&')}`) as string;
};
